import * as React from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useTheme } from "@mui/material/styles";
import { Box } from "@mui/material";
import { SelectInputPropsType } from "../../interface/input";
import { labelSty, styInput } from "./styles-input";
 

// export const useStyles = makeStyles((theme) => ({
//   customSelect: {
//     "& .MuiSelect-select": {
//       backgroundColor: "#ffffff",
//       borderRadius: "8px", // Adjust this value as needed
//     },
//     iconButton: {
//       padding: "8px", // Adjust padding as needed
//     },
//     icon: {
//       fontSize: "20px", // Adjust size as needed
//       color: "#757575", // Adjust color as needed
//     },
//   },
// }));

export function SelectInputBgWhite({
  label,
  value,
  onChange,
  options,
}: SelectInputPropsType) {
  const theme = useTheme();
  // const classes = useStyles();
  return (
    <Box sx={{ my: 2, width: "100%" }}>
      <InputLabel
        sx={{
          ...labelSty,
          color: theme.palette.common.black,
        }}
      >
        {label}
      </InputLabel>
      <FormControl sx={{ m: 1, width: "100%" }}>
        <Select
          // className={classes.customSelect}
          value={value}
          label="Age"
          onChange={onChange}
          sx={{ width: "100%", ...styInput }}
        >
          {options?.map((val, id) => (
            <MenuItem key={id} value={val.value}>
              {val.value}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}
